//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladProcesRealizaceDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-12-02                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.38.1
//AdtGeneratorConfig:[ T:(srvvprr) GID:(Web.Set.Des.Ts) V1:(ixs_prr,ixs_tip,priz_pov,priz_pov_ixb,aktivita,dat_zmena,zmenu_prov,priz_nevyzad,ixs_sro_predklad,ixs_sro_schvalov,ixs_tip_next,priz_pov_zapl,priz_pov_kompl,priz_pov_schv) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeInstitutPredpokladProcesRealizaceDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeInstitutPredpokladProcesRealizaceDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_prr */
            public ixs_prr: string;
            /** PK - ixs_tip */
            public ixs_tip: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeInstitutPredpokladProcesRealizaceListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeInstitutPredpokladProcesRealizaceDesigner>, ixs_prr: string,ixs_tip: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_prr, ixs_tip);
            v_form.addRow("jres:33000159").addField("gselectbox", Gordic.Prefabs.Select.admSrvsprr(), {
                dropdown: false,
                name: "ixs_prr",
                model: "model.ixs_prr=value.ixs_prr",
                initialValue: ixs_prr ? { ixs_prr: ixs_prr } : null,
                //graphicInput: "oninput",
                disabled: ixs_prr ? true : false,
            })
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, {
                hardDefaultFilter: {
                    ixs_prr: ixs_prr,
                    ixs_tip: ixs_tip
                }
            });
            
            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeInstitutPredpokladProcesRealizaceDesigner>, ixs_prr: string,ixs_tip: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeInstitutPredpokladProcesRealizaceDesigner>, ev, ctx): any {
            var filterObj = {
                ixs_prr: SeznamBase.filterContains(ctx.filter, "ixs_prr")
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitutPredpokladProcesRealizace.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeInstitutPredpokladProcesRealizaceDesignerInit
         * 
         * @param {GContentType<SeznamAdeInstitutPredpokladProcesRealizaceDesigner>} that
         */
        static SeznamAdeInstitutPredpokladProcesRealizaceDesignerInit(that: GContentType<SeznamAdeInstitutPredpokladProcesRealizaceDesigner>, ixs_prr: string,ixs_tip: string ) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_prr, ixs_tip);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, ixs_prr, ixs_tip)

        } // SeznamAdeInstitutPredpokladProcesRealizaceDesignerInit

        static LoadData(that: GContentType<SeznamAdeInstitutPredpokladProcesRealizaceDesigner>, ixs_prr: string, ixs_tip: string) {
            var filterObj: any = {}
            if (ixs_prr) {
                new Gordic.Data.Readers.AdmSrvsprr().getData({ ixs_prr: ixs_prr }).done((o) => {
                    that.filter.findFields("ixs_prr").gfield("setInitial", o[0]);
                })
                filterObj.ixs_prr = ixs_prr;
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitutPredpokladProcesRealizace.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }

    }
}
